import Course from '../types/Course';
import CourseResource from '../types/CourseResource';

import client from './client';

export const getCourseResources = (id: Course['id']) =>
  client.get<CourseResource[]>(`/courses/${id}/resources`);
